<mat-card class="cardWithShadow">
    <mat-card-header class="justify-content-between">
        <mat-card-title class="d-flex align-items-center justify-content-between">
            <div style="flex: 1;">Rendimento</div>

        </mat-card-title>
        <button mat-stroked-button color="primary" class="d-inline-flex detail-button" (click)="scoreDetails()">
            <div class="d-inline-flex" style="margin-top:6px">
                <i-tabler name="gauge" class="icon-20 text-primary"></i-tabler>
                <div>Dettaglio</div>
            </div>
        </button>
    </mat-card-header>
    <mat-card-content>
        <div class="text-center">
            <circle-progress class="score-gauge" [backgroundColor]="chart.backgroundColor"
                [backgroundStrokeWidth]="chart.backgroundStrokeWidth" [backgroundPadding]="chart.backgroundPadding"
                [radius]="chart.radius" [space]="chart.space" [toFixed]="chart.toFixed" [maxPercent]="chart.maxPercent"
                [outerStrokeWidth]="chart.outerStrokeWidth" [outerStrokeColor]="chart.outerStrokeColor"
                [title]="chart.title" [titleColor]="chart.titleColor" [titleFontSize]="chart.titleFontSize"
                [subtitle]="chart.subtitle" [subtitleFontSize]="chart.subtitleFontSize"
                [subtitleColor]="chart.subtitleColor" [animationDuration]="chart.animationDuration"
                [showInnerStroke]="chart.showInnerStroke" [responsive]="chart.responsive" [lazy]="chart.lazy"
                [percent]="chart.percent" [showSubtitle]="chart.showSubtitle" [units]="chart.units">
            </circle-progress>
        </div>
    </mat-card-content>
</mat-card>